export const LAUNCH_PROMO = {
  code: 'LAUNCH30',
  discountPercent: 30,
  durationMonths: 1,
} as const;
